var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input input--radio",class:{
    'input--error': _vm.error,
    'input--disabled': _vm.disabled,
    'input--checked': _vm.checked,
  },on:{"mouseover":function($event){return _vm.$emit('mouseover')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},[_c('input',{attrs:{"id":_vm.id,"type":"radio","name":_vm.name,"required":_vm.required,"disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"input":_vm.input}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.id}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }